import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=4055a80c&scoped=true&"
import script from "./aside.vue?vue&type=script&lang=js&"
export * from "./aside.vue?vue&type=script&lang=js&"
import style0 from "./aside.vue?vue&type=style&index=0&id=4055a80c&lang=less&scoped=true&"
import style1 from "./aside.vue?vue&type=style&index=1&id=4055a80c&lang=less&scoped=true&"
import style2 from "./aside.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4055a80c",
  null
  
)

export default component.exports